import React from 'react';
import PropTypes from 'prop-types';
import _startCase from 'lodash/startCase';
import styled from 'styled-components';
import {
  $white,
  $medium,
  $black,
  $red,
  $steelBlue,
  $gold,
} from '../../styles';

const StatusBadgeBase = styled.div`
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  font-weight: ${$medium};
  font-size: 0.75rem;
  margin: ${({ margin }) => margin || '0'};
  white-space: nowrap;
`;

const OnSaleBadge = styled(StatusBadgeBase)`
  background: ${$gold};
  color: ${$black};
`;

const OffSaleBadge = styled(StatusBadgeBase)`
  background: ${$steelBlue};
  color: ${$white};
`;

const SoldOutBadge = styled(StatusBadgeBase)`
  background: ${$red};
  color: ${$white};
`;

const ArchivedBadge = SoldOutBadge;

const statusBadgeMap = {
  ON_SALE: OnSaleBadge,
  OFF_SALE: OffSaleBadge,
  SOLD_OUT: SoldOutBadge,
  ARCHIVED: ArchivedBadge,
};

const StatusBadge = ({ status, margin }) => {
  const StatusBadgeElement = statusBadgeMap[status];
  const readableStatus = _startCase(status);
  return <StatusBadgeElement margin={margin}>{ readableStatus }</StatusBadgeElement>;
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  margin: PropTypes.string,
};

StatusBadge.defaultProps = {
  margin: '',
};

export default StatusBadge;
